module.exports = __webpack_public_path__ + "static/media/contrax-blue-logo.30874e43.svg";